import { Money } from "../../../../shared/money/Money";
import type { PortalInvoice, PortalOverview, PortalPayment } from "../../store/portalOverviewApi";
import { DateOnly } from "../../lib/DateOnly";

export const portalOverviewView = {
  create(overview: PortalOverview, today: string) {
    const isCredit = Money.isNegative(overview.accountBalance);
    const canPay = Money.isPositive(overview.accountBalance);
    const due = overview.earliestOpenInvoiceDueDate;
    return {
      canPay,
      balanceLabel: isCredit ? "Account credit" : "Account balance",
      balance: Money.abs(overview.accountBalance),
      paidMessage: isCredit
        ? "You have a credit. No payment needed."
        : Money.isZero(overview.accountBalance)
          ? "You're all paid up."
          : null,
      dueLabel:
        canPay && due ? `${due < today ? "Overdue ·" : "Due"} ${DateOnly.format(due)}` : null,
    };
  },
  invoiceStatus(invoice: PortalInvoice): "Open" | "Partially paid" {
    return Money.isPositive(invoice.paid) || Money.isPositive(invoice.creditApplied)
      ? "Partially paid"
      : "Open";
  },
  paymentDetail(payment: PortalPayment): string {
    const method =
      payment.method === "card"
        ? payment.card?.last4
          ? `${payment.card.brand || "Card"} ending ${payment.card.last4}`
          : "Card payment"
        : ({ bank: "Bank payment", cash: "Cash payment", check: "Check payment" } as const)[
            payment.method
          ];
    return Money.isPositive(payment.refundedAmount)
      ? `${method} · ${Money.format(payment.refundedAmount)} refunded`
      : method;
  },
};
